/* IMPORT */
import channel from './channel.js';
/* MAIN */
const red = (color) => {
    return channel(color, 'r');
};
/* EXPORT */
export default red;
